// extracted by mini-css-extract-plugin
export var configurationSection = "_rr-0";